import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@store/theme/design";
import { contentSpacingStyles, titleSpacingStyles } from "@store/theme/mixins";
import { polyfillCss } from "@store/theme/polyfills";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";

export default {
    fontFamilyImportUrl:
        "https://fonts.googleapis.com/css2?family=Heebo:ital,wght@0,400;0,700;0,900;1,400;1,700;1,900&display=swap",
    body: {
        fontFamily: TYPOGRAPHY.fontFamily.base,
        lineHeight: TYPOGRAPHY.lineHeight.base,
        size: TYPOGRAPHY.size.base,
        weight: TYPOGRAPHY.weight.base,
    },
    legend: {
        size: TYPOGRAPHY.size.tiny,
        weight: TYPOGRAPHY.weight.bold,
        color: COLORS.text.base,
        transform: "uppercase",
    },
    p: {
        size: "inherit",
        weight: "inherit",
        css: polyfillCss`
            ${contentSpacingStyles()}
        `,
    },
    h1: {
        size: 29,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, 31, 37, null, 48], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h2: {
        size: 22,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.25,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 22, null, 22], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h3: {
        size: 20,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.3,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 20, null, 20], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h4: {
        size: 18,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.3,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 18, null, 18], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h5: {
        size: 16,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.3,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 16, null, 16], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h6: {
        size: 14,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.3,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, 14, null, 14], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    headerPrimary: {
        transform: "none",
        size: 29,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, 31, 37, null, 70], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    headerSecondary: {
        transform: "none",
        size: 22,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, null, null, 50], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    headerTertiary: {
        transform: "none",
        size: 20,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: polyfillCss`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, null, null, 30], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
};
